import React, { Component, Fragment, useRef } from "react";
import * as PropTypes from "prop-types";
import axios from "axios";
import moment from 'moment';
import { Button, Col, Form, Input, InputNumber, message, Modal, Row, Select, Spin, Switch } from "antd";

import { API_ERRO_TYPE_CANCEL } from "../../config/general";

import { employeesService, perimetersService, departmentsService, companiesService, journeysService, functionsService, annualLeaveService } from "../../redux/services";
import MaskedInput from "react-text-mask"

import ModalDepartmentCreate from "./departmentCreate";
import ModalFunctionsCreate from "./functionCreate";
import ModalJourneyShow from "./../Journeys/show";
import ModalAnnualLeaveShow from "./../AnnualLeave/show";

import Adresses from "./Adresses";
import Contacts from "./Contacts";

import { debounce } from 'lodash';

import {
	DatePickerWithMask,
	UIDrawerForm,
	UIFormSection,
	UISteps,
	UISwitchField,
	UIUpload,
} from "../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

const STEPS = [
	{ key: "general", label: "Informações gerais" },
	{ key: "contract", label: "Contrato" },
	{ key: "app", label: "Parâmetros REP-P" },
	{ key: "equipments", label: "Credenciais REP-C" },
	{ key: "adresses", label: "Endereços" },
	{ key: "contacts", label: "Contatos" },
];

export const STEP_FIELDS = {
	general: ["nome", "cpf", "data_nascimento", "sexo", "nacionalidade", "naturalidade", "nome_pai", "nome_mae", "ativo", "numero_folha", "numero_identificador", "pis_pasep", "ctps", "rg", "rg_data_expedicao", "rg_ssp"],
	contract: ["empresa_id", "departamento_id", "funcao_id", "jornada_id", "banco_horas_id", "data_admissao", "data_inicio_cartao_ponto", "data_demissao", "arquivar"],
	app: ["app", "email", "password", "habilitar_app_empresa", "pin", "permitir_registro_app", "permitir_assinar_cartao_app", "exigir_senha_assinatura", "permitir_justificativa_parcial_app", "justificativa_parcial_app_auto_aprovar", "envio_self", "perimetro_id"],
	equipments: ["equipamento_senha", "equipamento_codigo_barras", "equipamento_rfid", "equipamento_enviar_rfid", "equipamento_admin", "equipamento_biometria"],
};

export const EmployeeGeneralFields = ({ uploadRef, nomeRef, statusLocked }) => {
	const sexoRef = useRef(null);
	const rgSspRef = useRef(null);

	return (
		<Fragment>
			<UIFormSection
				icon={<i className="fal fa-user" />}
				title="Dados pessoais"
				description="Identificação e dados pessoais do funcionário."
			>
				<Row gutter={16}>
					<Col xs={24} md={4}>
						<UIUpload
							name="avatar"
							ref={uploadRef}
							label="Foto"
							labelError="Foto"
							acceptedFiles={['jpg', 'jpeg', 'png']}
						/>
					</Col>
					<Col xs={24} md={20}>
						<Row gutter={16}>
							<Col xs={24} md={16}>
								<Form.Item name="nome" label="Nome" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input
										ref={nomeRef}
										placeholder="Digite o nome completo"
										onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} md={8}>
								<Form.Item name="cpf" label="CPF" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
									<MaskedInput
										mask={[/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
										className="ant-input"
										placeholder="000.000.000-00"
										onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={8}>
								<DatePickerWithMask
									onKeyUp={(e) => {
										if (e.keyCode === 13 || e.keyCode === 9) {
											sexoRef.current && sexoRef.current.focus()
										}
									}}
									name="data_nascimento"
									label="Data de nascimento"
									disableDateAfter={true}
								/>
							</Col>
							<Col xs={24} md={8}>
								<Form.Item name="sexo" label="Sexo">
									<Select
										ref={sexoRef}
										placeholder="Selecione"
										optionFilterProp="children"
										filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
										allowClear
										showSearch>
										<Select.Option value="0">Masculino</Select.Option>
										<Select.Option value="1">Feminino</Select.Option>
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} md={8}>
								<Form.Item name="nacionalidade" label="Nacionalidade" hasFeedback>
									<Input onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
								</Form.Item>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} md={8}>
						<Form.Item name="naturalidade" label="Naturalidade" hasFeedback>
							<Input onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
						</Form.Item>
					</Col>
					<Col xs={24} md={8}>
						<Form.Item name="nome_pai" label="Nome do pai" hasFeedback>
							<Input onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
						</Form.Item>
					</Col>
					<Col xs={24} md={8}>
						<Form.Item name="nome_mae" label="Nome da mãe" hasFeedback>
							<Input onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} md={8}>
						<UISwitchField
							bordered
							title="Ativo"
							description={statusLocked ? "Não é possível alterar o status pois o funcionário possui um contrato ativo." : "Funcionário ativo no sistema."}
						>
							<Form.Item name="ativo" valuePropName="checked" noStyle>
								<Switch disabled={statusLocked} />
							</Form.Item>
						</UISwitchField>
					</Col>
				</Row>
			</UIFormSection>
			<UIFormSection
				icon={<i className="fal fa-id-card" />}
				title="Documentos"
				description="Documentos e números de identificação usados na folha e no ponto."
			>
				<Row gutter={16}>
					<Col xs={24} md={8}>
						<Form.Item name="numero_folha" label="Número da folha" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
							<InputNumber type="number" style={{ width: "100%" }} onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
						</Form.Item>
					</Col>
					<Col xs={24} md={8}>
						<Form.Item name="numero_identificador" label="Número do identificador" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
							<InputNumber type="number" style={{ width: "100%" }} onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
						</Form.Item>
					</Col>
					<Col xs={24} md={8}>
						<Form.Item name="pis_pasep" label="PIS/PASEP">
							<MaskedInput
								className="ant-input"
								mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/,]}
								placeholder="000.00000.00-0"
								onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} md={6}>
						<Form.Item name="ctps" label="CTPS">
							<InputNumber type="number" style={{ width: "100%" }} onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} />
						</Form.Item>
					</Col>
					<Col xs={24} md={6}>
						<Form.Item name="rg" label="RG" hasFeedback>
							<MaskedInput
								mask={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/]}
								className="ant-input"
								placeholder="00.000.000-0"
								onDragStart={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()}
							/>
						</Form.Item>
					</Col>
					<Col xs={24} md={6}>
						<DatePickerWithMask
							onKeyUp={(e) => {
								if (e.keyCode === 13 || e.keyCode === 9) {
									rgSspRef.current && rgSspRef.current.focus()
								}
							}}
							name="rg_data_expedicao"
							label="Data de expedição"
							disableDateAfter={true}
						/>
					</Col>
					<Col xs={24} md={6}>
						<Form.Item name="rg_ssp" label="SSP" hasFeedback>
							<Input ref={rgSspRef} />
						</Form.Item>
					</Col>
				</Row>
			</UIFormSection>
		</Fragment>
	);
};

export const EmployeeAppFields = ({
	displayAppEmployee,
	displayAppCompany,
	perimeters,
	perimetersIsLoading,
	onPerimetersDropdownVisibleChange,
	onPerimetersSearch,
	passwordInput = <Input minLength={6} placeholder="Mínimo de 6 caracteres" />,
}) => (
	<Fragment>
		<UIFormSection
			icon={<i className="fal fa-mobile-alt" />}
			title="Aplicativos"
			description="Acesso do funcionário aos aplicativos de registro de ponto."
		>
			<Row gutter={16}>
				{displayAppEmployee && (
					<Col xs={24} md={12}>
						<UISwitchField
							bordered
							title="Aplicativo do funcionário"
							description="Libera o app do funcionário, com acesso por e-mail e senha."
						>
							<Form.Item name="app" valuePropName="checked" noStyle>
								<Switch />
							</Form.Item>
						</UISwitchField>
						<Form.Item noStyle shouldUpdate={(prev, cur) => prev.app !== cur.app}>
							{({ getFieldValue }) => getFieldValue("app") && (
								<Row gutter={16} style={{ marginTop: 16 }}>
									<Col xs={24} md={12}>
										<Form.Item name="email" label="E-mail" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
											<Input placeholder="E-mail de acesso ao app" />
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item name="password" label="Senha" hasFeedback rules={[
											{ min: 6, message: "Deve conter no mínimo 6 caracteres." },
											{ required: true, message: "Campo obrigatório." }
										]}>
											{passwordInput}
										</Form.Item>
									</Col>
								</Row>
							)}
						</Form.Item>
					</Col>
				)}
				{displayAppCompany && (
					<Col xs={24} md={12}>
						<UISwitchField
							bordered
							title="Aplicativo da empresa"
							description="Permite registrar o ponto no app da empresa usando um PIN."
						>
							<Form.Item name="habilitar_app_empresa" valuePropName="checked" noStyle>
								<Switch />
							</Form.Item>
						</UISwitchField>
						<Form.Item noStyle shouldUpdate={(prev, cur) => prev.habilitar_app_empresa !== cur.habilitar_app_empresa}>
							{({ getFieldValue }) => getFieldValue("habilitar_app_empresa") && (
								<Row gutter={16} style={{ marginTop: 16 }}>
									<Col xs={24} md={12}>
										<Form.Item name="pin" label="PIN" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }, { min: 4, max: 4, message: "Deve conter 4 caracteres." }]}>
											<Input type="number" style={{ width: "100%" }} placeholder="4 dígitos" />
										</Form.Item>
									</Col>
								</Row>
							)}
						</Form.Item>
					</Col>
				)}
			</Row>
		</UIFormSection>
		<Form.Item noStyle shouldUpdate={(prev, cur) => prev.app !== cur.app}>
			{({ getFieldValue }) => getFieldValue("app") && (
				<UIFormSection
					icon={<i className="fal fa-user-lock" />}
					title="Permissões no aplicativo"
					description="O que o funcionário pode fazer pelo app."
				>
					<Row gutter={[16, 16]}>
						<Col xs={24} md={8}>
							<UISwitchField bordered title="Registrar ponto" description="Registra o ponto pelo app.">
								<Form.Item name="permitir_registro_app" valuePropName="checked" noStyle>
									<Switch />
								</Form.Item>
							</UISwitchField>
						</Col>
						<Col xs={24} md={8}>
							<UISwitchField bordered title="Assinar cartão ponto" description="Assina o cartão ponto pelo app.">
								<Form.Item name="permitir_assinar_cartao_app" valuePropName="checked" noStyle>
									<Switch />
								</Form.Item>
							</UISwitchField>
						</Col>
						<Col xs={24} md={8}>
							<Form.Item noStyle shouldUpdate={(prev, cur) => prev.permitir_assinar_cartao_app !== cur.permitir_assinar_cartao_app}>
								{({ getFieldValue }) => getFieldValue("permitir_assinar_cartao_app") && (
									<UISwitchField bordered title="Exigir senha ao assinar" description="Pede a senha do app na assinatura.">
										<Form.Item name="exigir_senha_assinatura" valuePropName="checked" noStyle>
											<Switch />
										</Form.Item>
									</UISwitchField>
								)}
							</Form.Item>
						</Col>
						<Col xs={24} md={8}>
							<UISwitchField bordered title="Anexar justificativas e marcações manuais" description="Envia justificativas e marcações pelo app.">
								<Form.Item name="permitir_justificativa_parcial_app" valuePropName="checked" noStyle>
									<Switch />
								</Form.Item>
							</UISwitchField>
						</Col>
						<Col xs={24} md={8}>
							<Form.Item noStyle shouldUpdate={(prev, cur) => prev.permitir_justificativa_parcial_app !== cur.permitir_justificativa_parcial_app}>
								{({ getFieldValue }) => getFieldValue("permitir_justificativa_parcial_app") && (
									<UISwitchField bordered title="Aprovar justificativas automaticamente" description="Justificativas enviadas pelo app entram aprovadas.">
										<Form.Item name="justificativa_parcial_app_auto_aprovar" valuePropName="checked" noStyle>
											<Switch />
										</Form.Item>
									</UISwitchField>
								)}
							</Form.Item>
						</Col>
					</Row>
				</UIFormSection>
			)}
		</Form.Item>
		<UIFormSection
			icon={<i className="fal fa-map-marker-alt" />}
			title="Registro de ponto"
			description="Regras aplicadas na marcação pelo app."
		>
			<Row gutter={16}>
				<Col xs={24} md={12}>
					<UISwitchField bordered title="Envio de selfie" description="Exige uma selfie a cada registro de ponto.">
						<Form.Item name="envio_self" valuePropName="checked" noStyle>
							<Switch />
						</Form.Item>
					</UISwitchField>
				</Col>
				<Form.Item noStyle shouldUpdate={(prev, cur) => prev.app !== cur.app || prev.habilitar_app_empresa !== cur.habilitar_app_empresa}>
					{({ getFieldValue }) => (getFieldValue("habilitar_app_empresa") || getFieldValue("app")) && (
						<Col xs={24} md={12}>
							<Form.Item name="perimetro_id" label="Perímetro" hasFeedback>
								<Select
									filterOption={false}
									allowClear
									placeholder="Escolha o perímetro"
									notFoundContent={perimetersIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
									onDropdownVisibleChange={onPerimetersDropdownVisibleChange}
									onSearch={onPerimetersSearch}
									showSearch
								>
									{perimeters.map((item, index) => (
										<Select.Option key={index} value={item.id}>
											{item.nome}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>
					)}
				</Form.Item>
			</Row>
		</UIFormSection>
	</Fragment>
);

export const EmployeeEquipmentsFields = () => (
	<UIFormSection
		icon={<i className="fal fa-fingerprint" />}
		title="Credenciais do equipamento"
		description="Dados de acesso do funcionário no relógio de ponto (REP-C)."
	>
		<Row gutter={16}>
			<Col xs={24} md={8}>
				<Form.Item name="equipamento_senha" label="Senha do equipamento" hasFeedback>
					<InputNumber type="number" style={{ width: "100%" }} />
				</Form.Item>
			</Col>
			<Col xs={24} md={8}>
				<Form.Item name="equipamento_codigo_barras" label="Código de barras" hasFeedback>
					<Input />
				</Form.Item>
			</Col>
			<Col xs={24} md={8}>
				<Form.Item name="equipamento_rfid" label="RFID" hasFeedback>
					<Input style={{ width: "100%" }} />
				</Form.Item>
			</Col>
		</Row>
		<Row gutter={[16, 16]}>
			<Col xs={24} md={8}>
				<UISwitchField bordered title="Enviar RFID" description="Envia o RFID do funcionário ao equipamento.">
					<Form.Item name="equipamento_enviar_rfid" valuePropName="checked" noStyle>
						<Switch />
					</Form.Item>
				</UISwitchField>
			</Col>
			<Col xs={24} md={8}>
				<UISwitchField bordered title="Administrador" description="Funcionário é administrador do equipamento.">
					<Form.Item name="equipamento_admin" valuePropName="checked" noStyle>
						<Switch />
					</Form.Item>
				</UISwitchField>
			</Col>
			<Col xs={24} md={8}>
				<UISwitchField bordered title="Biometria" description="Funcionário usa biometria no equipamento.">
					<Form.Item name="equipamento_biometria" valuePropName="checked" noStyle>
						<Switch />
					</Form.Item>
				</UISwitchField>
			</Col>
		</Row>
	</UIFormSection>
);

class Create extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};


	constructor(props) {
		super(props);

		this.state = {
			arquivar: false,
			isLoading: false,
			isSending: false,
			nextOrder: 1,
			selectedAnnualLeave: null,
			selectedJourney: null,
			selectedFunction: null,
			selectedDepartment: null,
			type: null,
			companiesIsLoading: false,
			companies: [],
			departmentsIsLoading: false,
			departments: [],
			functionsIsLoading: false,
			functions: [],
			annualLeaveIsLoading: false,
			annualLeave: [],
			journeysIsLoading: false,
			journeys: [],
			perimetersIsLoading: false,
			perimeters: [],
			displayParamsREPP: true,
			displayAppCompany: true,
			displayAppEmployee: true,
			activeKey: "general",
			uuid: null,
			item: null,
		};

		this._submitIntent = "continue";
	}

	componentDidMount() {
		this.handleCheckCompanyHasAccessREPP();
	}

	onOpen = () => {
		this.setState({
			selectedAnnualLeave: null,
			selectedJourney: null,
			selectedFunction: null,
			selectedDepartment: null,
			activeKey: "general",
			uuid: null,
			item: null,
		})

		setTimeout(() => {
			this.nome && this.nome.focus()

		}, 100)
	};

	/**
	 * Journey Show
	 *
	 * @param uuid
	 */
	journeyShowOpen = ({ uuid }) => {
		this.setState({ journeyShowModalVisible: true });

		// On open screen
		this.journeyShowScreen.onOpen(this.state.selectedJourney);
	};

	journeyShowOnClose = () => {
		this.setState({ journeyShowModalVisible: false });
	};

	/**
	 * AnnualLeave Show
	 *
	 * @param uuid
	 */
	annualLeaveShowOpen = ({ uuid }) => {
		this.setState({ annualLeaveShowModalVisible: true });

		// On open screen
		this.annualLeaveShowScreen.onOpen(this.state.selectedAnnualLeave);
	};

	annualLeaveShowOnClose = () => {
		this.setState({ annualLeaveShowModalVisible: false });
	};

	/**
	  * Department Create
	  */
	departmentCreateOpen = (contract) => {
		this.setState({ departmentCreateModalVisible: true });

		// On open screen
		this.departmentCreateScreen.onOpen(contract ?? null);
	};

	departmentCreateOnClose = () => {
		this.setState({ departmentCreateModalVisible: false });
		this.departamento_id && this.departamento_id.focus();
	};

	departmentCreateOnComplete = (item, contract) => {
		this.setState({ departmentCreateModalVisible: false });

		this.departamento_id && this.departamento_id.focus();
		this.form.setFieldsValue({ departamento_id: item.id })
		this.setState({ selectedDepartment: item.nome })

	};

	/**
	  * Function Create
	  */
	functionCreateOpen = () => {
		this.setState({ functionCreateModalVisible: true });

		// On open screen
		this.functionCreateScreen.onOpen();
	};

	functionCreateOnClose = () => {
		this.setState({ functionCreateModalVisible: false });
		this.funcao_id && this.funcao_id.focus();
	};

	functionCreateOnComplete = (item) => {
		this.setState({ functionCreateModalVisible: false });

		this.funcao_id && this.funcao_id.focus();
		this.form.setFieldsValue({ funcao_id: item.id })
		this.setState({ selectedFunction: item.nome })
	};

	fetchCompaniesSearch = debounce((value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (!value.trim().length) {
			// this.setState({
				// companiesIsLoading: false,
				// companies: [],
			// });

			// return false;
		// }

		this.setState({
			companiesIsLoading: true,
		});

		companiesService.getAll({
			...(value ? { search: value } : {}),
			ativo: 1,
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					companiesIsLoading: false,
					companies: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					companiesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}, 1000);

	fetchCompanies = () => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		this.setState({
			companiesIsLoading: true,
		});

		companiesService.getAll({ cancelToken: this._axiosCancelTenantsToken.token, ativo: 1 })
			.then((response) => {
				this.setState({
					companiesIsLoading: false,
					companies: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					companiesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchPerimetersSearch = debounce((value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (!value.trim().length) {
			// this.setState({
				// perimetersIsLoading: false,
				// perimeters: [],
			// });

			// return false;
		// }

		this.setState({
			perimetersIsLoading: true,
		});

		perimetersService.getAutocomplete({
			...(value ? { search: value } : {}),
			status: 1,
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					perimetersIsLoading: false,
					perimeters: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					perimetersIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}, 500);

	fetchPerimeters = () => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		this.setState({
			perimetersIsLoading: true,
		});

		perimetersService.getAutocomplete({
			status: 1,
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					perimetersIsLoading: false,
					perimeters: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					perimetersIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchDepartmentsSearch = debounce((value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (!value.trim().length) {
			// this.setState({
				// departmentsIsLoading: false,
				// departments: [],
			// });

			// return false;
		// }

		this.setState({
			departmentsIsLoading: true,
		});

		departmentsService.getAll({
			...(value ? { search: value } : {}),
			is_active: 1,
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					departmentsIsLoading: false,
					departments: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					departmentsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}, 1000);

	fetchDepartments = () => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		this.setState({
			departmentsIsLoading: true,
		});

		departmentsService.getAll({ cancelToken: this._axiosCancelTenantsToken.token, is_active: 1 })
			.then((response) => {
				this.setState({
					departmentsIsLoading: false,
					departments: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					departmentsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchFunctionsSearch = debounce((value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (!value.trim().length) {
			// this.setState({
				// functionsIsLoading: false,
				// functions: [],
			// });

			// return false;
		// }

		this.setState({
			functionsIsLoading: true,
		});

		functionsService.getAll({
			...(value ? { search: value } : {}),
			is_active: 1,
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					functionsIsLoading: false,
					functions: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					functionsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}, 1000);

	fetchFunctions = () => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		this.setState({
			functionsIsLoading: true,
		});

		functionsService.getAll({ cancelToken: this._axiosCancelTenantsToken.token, is_active: 1 })
			.then((response) => {
				this.setState({
					functionsIsLoading: false,
					functions: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					functionsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchAnnualLeaveSearch = debounce((value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (!value.trim().length) {
			// this.setState({
				// annualLeaveIsLoading: false,
				// annualLeave: [],
			// });

			// return false;
		// }

		this.setState({
			annualLeaveIsLoading: true,
		});

		annualLeaveService.getAll({
			...(value ? { search: value } : {}),
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					annualLeaveIsLoading: false,
					annualLeave: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					annualLeaveIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}, 1000);

	fetchAnnualLeave = () => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		this.setState({
			annualLeaveIsLoading: true,
		});

		annualLeaveService.getAll({cancelToken: this._axiosCancelTenantsToken.token})
			.then((response) => {
				this.setState({
					annualLeaveIsLoading: false,
					annualLeave: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					annualLeaveIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchJourneysSearch = debounce((value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (!value.trim().length) {
			// this.setState({
				// journeysIsLoading: false,
				// journeys: [],
			// });

			// return false;
		// }

		this.setState({
			journeysIsLoading: true,
		});

		journeysService.getAll({
			...(value ? { search: value } : {}),
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					journeysIsLoading: false,
					journeys: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					journeysIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}, 1000);

	fetchJourneys = () => {		
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		this.setState({
			journeysIsLoading: true,
		});

		journeysService.getAll({cancelToken: this._axiosCancelTenantsToken.token})
			.then((response) => {
				this.setState({
					journeysIsLoading: false,
					journeys: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					journeysIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onClose = () => {
		if (this.state.uuid) {
			this.props.onComplete();
		} else {
			this.props.onClose();
		}
	};

	onFinish = (values) => {
		if (this.state.uuid) return;

		const file = this.upload.getFiles();

		if (file.hasError) {
			Modal.error({
				title: "Ocorreu um erro!",
				content: file.error,
			});

			return false;
		}
		this.setState({
			isSending: true,
		});

		const data = { ...values };

		if (data.data_demissao) {
			data.data_demissao = data.data_demissao.format("YYYY-MM-DD");
		}

		if (data.novo_contrato_data_admissao) {
			data.novo_contrato_data_admissao = data.novo_contrato_data_admissao.format("YYYY-MM-DD");
		}

		if (data.data_admissao) {
			data.data_admissao = data.data_admissao.format("YYYY-MM-DD");
		}

		if (data.data_inicio_cartao_ponto) {
			data.data_inicio_cartao_ponto = data.data_inicio_cartao_ponto.format("YYYY-MM-DD");
		}

		if (data.data_nascimento) {
			data.data_nascimento = data.data_nascimento.format("YYYY-MM-DD");
		}

		if (data.rg_data_expedicao) {
			data.rg_data_expedicao = data.rg_data_expedicao.format("YYYY-MM-DD");
		}

		if (file.files.length) {
			if (!file.files[0].uuid) {
				data.avatar = file.files[0];
			}
		}
		else {
			data.avatar = null;
		}

		if (data.pin) {
			const numbers = data.pin.split("_")
			data.pin = numbers[0]
		}

		if (data.banco_horas_id) {
			data["vinculo[0][banco_horas_id]"] = data.banco_horas_id
		}

		data.pis_pasep = (data.pis_pasep || '').replaceAll('.', '').replace('-', '')

		employeesService.create(data)
			.then((response) => {
				// Success message
				message.success("Funcionário cadastrado com sucesso.");

				if (this._submitIntent === "exit") {
					this.setState({
						isSending: false,
					});

					// Callback
					this.props.onComplete();

					return;
				}

				const uuid = response.data.data.uuid;

				this.setState({ uuid });

				employeesService.show({ uuid })
					.then((showResponse) => {
						const item = showResponse.data.data;

						this.setState({
							isSending: false,
							item,
							activeKey: "adresses",
						}, () => {
							this.tabAdresses && this.tabAdresses.init(item);
							this.tabContacts && this.tabContacts.init(item);
						});
					})
					.catch((data) => {
						this.setState({
							isSending: false,
						});

						Modal.error({
							title: "Ocorreu um erro!",
							content: String(data),
							onOk: () => this.props.onComplete(),
						});
					});
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onFinishFailed = ({ errorFields }) => {
		const field = errorFields[0]?.name[0];
		const step = Object.keys(STEP_FIELDS).find((key) => STEP_FIELDS[key].includes(field));

		// O scrollToFirstError não alcança campo de etapa oculta
		if (step && step !== this.state.activeKey) {
			this.setState({ activeKey: step }, () => this.form.scrollToField(field));
		}
	};

	getSteps = () => {
		const { displayParamsREPP, uuid } = this.state;

		return STEPS
			.filter((step) => step.key !== "app" || displayParamsREPP)
			.map((step) => ({
				...step,
				// Antes do cadastro só as etapas do formulário; depois, só endereços e contatos
				disabled: STEP_FIELDS[step.key] ? !!uuid : !uuid,
			}));
	};

	goToNextStep = () => {
		const { activeKey } = this.state;
		const steps = this.getSteps();
		const nextStep = steps[steps.findIndex((step) => step.key === activeKey) + 1];

		this.form.validateFields(STEP_FIELDS[activeKey] || [])
			.then(() => this.setState({ activeKey: nextStep.key }))
			.catch(({ errorFields }) => errorFields.length && this.form.scrollToField(errorFields[0].name));
	};

	onDateLayOffChange = (value) => {
		this.handleSwitchArchive(value)
	}
	
	handleCheckCompanyHasAccessREPP = () => {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));

		this.setState({
			displayParamsREPP: !(!companyData?.app_empresa && !companyData?.app_funcionario),
			displayAppCompany: companyData?.app_empresa,
			displayAppEmployee: companyData?.app_funcionario
		});
	}

	handleSwitchArchive = (value) => {
		const archive = !!value && value.isSameOrBefore(moment(), 'day');
		this.form.setFieldValue('arquivar', archive);
		this.setState({
			arquivar: archive
		});
	}

	handleDropdownVisibleChange = (entity, fetchFunction) => {
		if (entity.length === 0) {
			fetchFunction();
		} 
	};

	renderFooter = (steps) => {
		const { isSending, activeKey, uuid } = this.state;

		const formSteps = steps.filter((step) => STEP_FIELDS[step.key]);
		const isLastFormStep = activeKey === formSteps[formSteps.length - 1].key;
		const prevStep = steps[steps.findIndex((step) => step.key === activeKey) - 1];

		let primaryAction;

		if (uuid) {
			primaryAction = activeKey === "adresses" ? (
				<Button type="primary" onClick={this.goToNextStep} icon={<i className="fal fa-arrow-right" />}>
					Próximo
				</Button>
			) : (
				<Button type="primary" onClick={() => this.props.onComplete()} icon={<i className="fal fa-check" />}>
					Concluir
				</Button>
			);
		} else if (isLastFormStep) {
			primaryAction = (
				<Button
					key="submit"
					type="primary"
					form={formId}
					htmlType="submit"
					loading={isSending}
					onClick={() => { this._submitIntent = "continue" }}
					icon={<i className="fal fa-arrow-right" />}
				>
					Salvar e continuar
				</Button>
			);
		} else {
			primaryAction = (
				<Button key="next" type="primary" onClick={this.goToNextStep} disabled={isSending} icon={<i className="fal fa-arrow-right" />}>
					Próximo
				</Button>
			);
		}

		return (
			<div className="drawer-form-wizard-footer">
				<div className="drawer-form-wizard-footer-actions">
					<Button onClick={this.onClose} disabled={isSending}>{uuid ? "Fechar" : "Cancelar"}</Button>
					{prevStep && !prevStep.disabled && (
						<Button onClick={() => this.setState({ activeKey: prevStep.key })} disabled={isSending} icon={<i className="fal fa-arrow-left" />}>
							Voltar etapa
						</Button>
					)}
				</div>
				<div className="drawer-form-wizard-footer-actions">
					{!uuid && (
						<Button
							className="action-btn-secondary"
							form={formId}
							htmlType="submit"
							loading={isSending}
							onClick={() => { this._submitIntent = "exit" }}
						>
							Salvar e sair
						</Button>
					)}
					{primaryAction}
				</div>
			</div>
		);
	};

	render() {
		const { visible } = this.props;

		const {
			isLoading,
			isSending,
			nextOrder,
			companies,
			companiesIsLoading,
			annualLeave,
			annualLeaveIsLoading,
			departments,
			departmentsIsLoading,
			functions,
			functionsIsLoading,
			journeys,
			journeysIsLoading,
			perimeters,
			perimetersIsLoading,
			displayParamsREPP,
			displayAppCompany,
			displayAppEmployee,
			activeKey,
			item,
		} = this.state;

		const steps = this.getSteps();

		return (
			<UIDrawerForm
				visible={visible}
				width={1100}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				showBtnSave={false}
				icon={<i className="fal fa-users" />}
				title="Incluir novo funcionário"
				subtitle="Preencha os dados do funcionário. Endereços e contatos são liberados após o cadastro."
				steps={
					<UISteps
						steps={steps}
						current={activeKey}
						onChange={(key) => this.setState({ activeKey: key })}
						hideNav
					/>
				}
				footer={this.renderFooter(steps)}
			>
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					onFinishFailed={this.onFinishFailed}
					initialValues={{
						order: nextOrder,
						required: true,
						ativo: true,
						permitir_justificativa_parcial_app: false,
						justificativa_parcial_app_auto_aprovar: false,
					}}>
					<div style={{ display: activeKey === "general" ? "block" : "none" }}>
						<EmployeeGeneralFields uploadRef={el => this.upload = el} nomeRef={el => this.nome = el} />
					</div>
					<div style={{ display: activeKey === "contract" ? "block" : "none" }}>
						<UIFormSection
							icon={<i className="fal fa-briefcase" />}
							title="Vínculo"
							description="Primeiro contrato do funcionário. Outros contratos podem ser incluídos na edição."
						>
							<Row gutter={16}>
								<Col xs={24} md={12}>
									<Form.Item name="empresa_id" label="Empresa" rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Select
											filterOption={false}
											allowClear
											placeholder="Escolha a empresa"
											notFoundContent={companiesIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
											onDropdownVisibleChange={() => this.handleDropdownVisibleChange(companies, this.fetchCompanies)}
											onSearch={this.fetchCompaniesSearch}
											showSearch
										>
											{companies.map((item, index) => (
												<Select.Option key={index} value={item.id}>
													{item.nome}
												</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="departamento_id" hasFeedback label="Departamento" rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Input.Group compact className="input-group-with-action">
											<Select
												filterOption={false}
												allowClear
												ref={el => this.departamento_id = el}												placeholder="Escolha o departamento"
												notFoundContent={departmentsIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
												onDropdownVisibleChange={() => this.handleDropdownVisibleChange(departments, this.fetchDepartments)}
												showSearch
												onSearch={this.fetchDepartmentsSearch}
												onChange={(value) => {
													this.setState({ selectedDepartment: value })
													this.form.setFieldsValue({ departamento_id: value })
												}}
												value={this.state.selectedDepartment}
											>
												{departments.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
											<Button className="action-btn-secondary" title="Cadastrar departamento" icon={<i className="far fa-plus" />} onClick={() => this.departmentCreateOpen()} />
										</Input.Group>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} md={12}>
									<Form.Item name="funcao_id" label="Função" rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Input.Group compact className="input-group-with-action">
											<Select
												filterOption={false}
												allowClear
												ref={el => this.funcao_id = el}												placeholder="Escolha a função"
												notFoundContent={functionsIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
												onDropdownVisibleChange={() => this.handleDropdownVisibleChange(functions, this.fetchFunctions)}
												showSearch
												onSearch={this.fetchFunctionsSearch}
												onChange={(value) => {
													this.setState({ selectedFunction: value })
													this.form.setFieldsValue({ funcao_id: value })
												}}
												value={this.state.selectedFunction}
											>
												{functions.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
											<Button className="action-btn-secondary" title="Cadastrar função" icon={<i className="far fa-plus" />} onClick={this.functionCreateOpen} />
										</Input.Group>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="jornada_id" label="Horário" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Input.Group compact className="input-group-with-action">
											<Select
												filterOption={false}
												allowClear												placeholder="Escolha o horário"
												notFoundContent={journeysIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
												onDropdownVisibleChange={() => this.handleDropdownVisibleChange(journeys, this.fetchJourneys)}
												onChange={(value) => {
													if (!value) {
														this.setState({ selectedJourney: null })
														this.form.setFieldsValue({ jornada_id: null })
													} else {
														this.setState({ selectedJourney: journeys.filter((journey) => journey.id == value)[0].uuid })
														this.form.setFieldsValue({ jornada_id: value })
													}
												}}
												showSearch
												onSearch={this.fetchJourneysSearch}
											>
												{journeys.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.descricao}
													</Select.Option>
												))}
											</Select>
											<Button className="action-btn-secondary" title="Visualizar horário" icon={<i className="far fa-eye" />} disabled={!this.state.selectedJourney} onClick={this.journeyShowOpen} />
										</Input.Group>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} md={12}>
									<Form.Item name="banco_horas_id" label="Banco de horas" hasFeedback>
										<Input.Group compact className="input-group-with-action">
											<Select
												ref={el => this.banco_horas_id = el}
												filterOption={false}
												allowClear												placeholder="Escolha o banco de horas"
												notFoundContent={annualLeaveIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
												onDropdownVisibleChange={() => this.handleDropdownVisibleChange(annualLeave, this.fetchAnnualLeave)}
												onChange={(value) => {
													if (!value) {
														this.setState({ selectedAnnualLeave: null })
														this.form.setFieldsValue({ banco_horas_id: null })
													} else {
														if (value != -1) {
															this.setState({ selectedAnnualLeave: annualLeave.filter((annual) => annual.id == value)[0].uuid })
														}

														this.form.setFieldsValue({ banco_horas_id: value })
													}
												}}
												showSearch
												onSearch={this.fetchAnnualLeaveSearch}
											>
												<Select.Option key={-1} value={-1}>
													Não vincular banco de horas
												</Select.Option>
												{annualLeave.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.descricao}
													</Select.Option>
												))}
											</Select>
											<Button className="action-btn-secondary" title="Visualizar banco de horas" icon={<i className="far fa-eye" />} disabled={!this.state.selectedAnnualLeave} onClick={this.annualLeaveShowOpen} />
										</Input.Group>
									</Form.Item>
								</Col>
							</Row>
						</UIFormSection>
						<UIFormSection
							icon={<i className="fal fa-calendar-alt" />}
							title="Período"
							description="Datas de admissão, início do cartão ponto e demissão."
						>
							<Row gutter={16}>
								<Col xs={24} md={8}>
									<DatePickerWithMask
										name="data_admissao"
										label="Data de admissão"
										required={true}
										onChange={() => {
											this.form.validateFields(["data_inicio_cartao_ponto", "data_demissao"]).catch(() => null);
										}}
									/>
								</Col>
								<Col xs={24} md={8}>
									<DatePickerWithMask
										name="data_inicio_cartao_ponto"
										label="Início do cartão ponto"
										required={true}
										onChange={() => {
											this.form.validateFields(["data_demissao"]).catch(() => null);
										}}
										rules={[
											{ required: true, message: 'Campo obrigatório.' },
											{ validator: (_, value) => {
												if (!value) return Promise.resolve();

												const data_admissao = this.form.getFieldValue('data_admissao')
												if (value.isBefore(data_admissao, "day")) {
													return Promise.reject(
														new Error(`A data não pode ser menor que a data de admissão`)
													);
												}
												return Promise.resolve();
											}}
										]}
									/>
								</Col>
								<Col xs={24} md={8}>
									<DatePickerWithMask
										name="data_demissao"
										label="Data de demissão"
										onChange={(value) => {
											this.onDateLayOffChange(value);
											this.form.validateFields(["data_demissao"]).catch(() => null);
										}}
										rules={[
											{ validator: (_, value) => {
												if (!value) return Promise.resolve();

												const data_admissao = this.form.getFieldValue('data_admissao');
												if (data_admissao && value.isBefore(data_admissao, "day")) {
													return Promise.reject(
														new Error(`A data não pode ser menor que a data de admissão`)
													);
												}

												const data_inicio_cartao_ponto = this.form.getFieldValue('data_inicio_cartao_ponto');
												if (data_inicio_cartao_ponto && value.isBefore(data_inicio_cartao_ponto, "day")) {
													return Promise.reject(
														new Error(`A data não pode ser menor que a data de início do cartão ponto`)
													);
												}

												return Promise.resolve();
											}}
										]}
									/>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} md={8}>
									<UISwitchField
										bordered
										title="Arquivar"
										description="Não mostra o contrato no cartão ponto e nos relatórios."
									>
										<Form.Item name="arquivar" valuePropName="checked" noStyle>
											<Switch />
										</Form.Item>
									</UISwitchField>
								</Col>
							</Row>
						</UIFormSection>
					</div>
					{displayParamsREPP && (
						<div style={{ display: activeKey === "app" ? "block" : "none" }}>
							<EmployeeAppFields
								displayAppEmployee={displayAppEmployee}
								displayAppCompany={displayAppCompany}
								perimeters={perimeters}
								perimetersIsLoading={perimetersIsLoading}
								onPerimetersDropdownVisibleChange={() => this.handleDropdownVisibleChange(perimeters, this.fetchPerimeters)}
								onPerimetersSearch={this.fetchPerimetersSearch}
							/>
						</div>
					)}
					<div style={{ display: activeKey === "equipments" ? "block" : "none" }}>
						<EmployeeEquipmentsFields />
					</div>
				</Form>
				{item && (
					<>
						<div style={{ display: activeKey === "adresses" ? "block" : "none" }}>
							<Adresses ref={el => this.tabAdresses = el} />
						</div>
						<div style={{ display: activeKey === "contacts" ? "block" : "none" }}>
							<Contacts ref={el => this.tabContacts = el} />
						</div>
					</>
				)}
				<ModalDepartmentCreate
					ref={el => this.departmentCreateScreen = el}
					visible={this.state.departmentCreateModalVisible}
					onComplete={this.departmentCreateOnComplete}
					onClose={this.departmentCreateOnClose}
				/>
				<ModalFunctionsCreate
					ref={el => this.functionCreateScreen = el}
					visible={this.state.functionCreateModalVisible}
					onComplete={this.functionCreateOnComplete}
					onClose={this.functionCreateOnClose}
				/>
				<ModalJourneyShow
					ref={el => this.journeyShowScreen = el}
					visible={this.state.journeyShowModalVisible}
					onClose={this.journeyShowOnClose}
				/>
				<ModalAnnualLeaveShow
					ref={el => this.annualLeaveShowScreen = el}
					visible={this.state.annualLeaveShowModalVisible}
					onClose={this.annualLeaveShowOnClose}
				/>
			</UIDrawerForm>
		)
	}
}

export default Create;
